<template>
    <v-footer align-center class="login-footer">
        <span> &copy; HoReCa / {{ new Date().getFullYear() }}</span>
    </v-footer>
</template>

<script>
    export default {
        name: 'Footer',
    }
</script>

<style lang="scss">
    .v-footer {
        background-color: transparent !important;
    }
</style>
